import * as React from "react";
import AdminApprovalSSNView from "./components/AdminApprovalSSN";

export default function AdminSSNApprovalViewPage() {
    return (
    <>
      <AdminApprovalSSNView />
    </>
  );
}